module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "reatribute-kanban",
    attrs: {
      "hide-footer": "",
      "title": 'Réatributer la carte Kanban ' + _vm.card,
      "size": "lg"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Fournisseur interne")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.supplier,
      "formatter": _vm.formatter,
      "maxlength": "4"
    },
    model: {
      value: (_vm.form.internal_supplier),
      callback: function($$v) {
        _vm.$set(_vm.form, "internal_supplier", $$v)
      },
      expression: "form.internal_supplier"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v("Client interne")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.customer,
      "formatter": _vm.formatter,
      "maxlength": "4"
    },
    model: {
      value: (_vm.form.internal_customer),
      callback: function($$v) {
        _vm.$set(_vm.form, "internal_customer", $$v)
      },
      expression: "form.internal_customer"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "info",
      "id": "nextBtn",
      "disabled": (this.isEmpty(this.form.internal_supplier) || this.isEmpty(this.form.internal_customer))
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("\n            Enregistrer\n          ")])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbdf0f1e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ReatributionFormModal.vue
// module id = 720
// module chunks = 1